import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';

// UTILITY
import { getS3ImageUrl } from '@/utility/content';

const todaysImg = getS3ImageUrl('/free-tv/todays-homeowner.png');
const todaysX2Img = getS3ImageUrl('/free-tv/todays-homeowner-x2.png');
const motorvisionImg = getS3ImageUrl('/free-tv/motorvision-tv.png');
const motorvisionX2Img = getS3ImageUrl('/free-tv/motorvision-tv-x2.png');
const mavTvImg = getS3ImageUrl('/free-tv/mavtv-x2.png');
const mavTvX2Img = getS3ImageUrl('/free-tv/mavtv-x2.png');
const sportsgridImg = getS3ImageUrl('/free-tv/sportsgrid.png');
const sportsgridX2Img = getS3ImageUrl('/free-tv/sportsgrid-x2.png');
const toonGogglesImg = getS3ImageUrl('/free-tv/toon-goggles.png');
const toonGogglesX2Img = getS3ImageUrl('/free-tv/toon-goggles-x2.png');
const QVCImg = getS3ImageUrl('/free-tv/QVC.png');
const QVCX2Img = getS3ImageUrl('/free-tv/QVC-x2.png');
const THCImg = getS3ImageUrl('/free-tv/THC.png');
const THCX2Img = getS3ImageUrl('/free-tv/THC-x2.png');
const giggleMugImg = getS3ImageUrl('/free-tv/giggle-mug.png');
const giggleMugX2Img = getS3ImageUrl('/free-tv/giggle-mug-x2.png');

const Channels = () => {
  const [t] = useTranslation();

  const { content } = useSelector(({ pages }) => ({
    content: pages.content,
  }));

  const channelsData = [
    {
      img: content.free_tv_channel_1_img || todaysImg,
      imgX2: content.free_tv_channel_1_img || todaysX2Img,
      title: content.free_tv_channel_1_name || "Today's Homeowner Media",
    },
    {
      img: content.free_tv_channel_2_img || motorvisionImg,
      imgX2: content.free_tv_channel_2_img || motorvisionX2Img,
      title: content.free_tv_channel_2_name || 'Motorvision TV',
    },
    {
      img: content.free_tv_channel_3_img || mavTvImg,
      imgX2: content.free_tv_channel_3_img || mavTvX2Img,
      title: content.free_tv_channel_3_name || 'MAVTV',
    },
    {
      img: content.free_tv_channel_4_img || sportsgridImg,
      imgX2: content.free_tv_channel_4_img || sportsgridX2Img,
      title: content.free_tv_channel_4_name || 'SportsGrid',
    },
    {
      img: content.free_tv_channel_5_img || toonGogglesImg,
      imgX2: content.free_tv_channel_5_img || toonGogglesX2Img,
      title: content.free_tv_channel_5_name || 'Toon Goggles',
    },
    {
      img: content.free_tv_channel_6_img || QVCImg,
      imgX2: content.free_tv_channel_6_img || QVCX2Img,
      title: content.free_tv_channel_6_name || 'QVC',
    },
    {
      img: content.free_tv_channel_7_img || THCImg,
      imgX2: content.free_tv_channel_7_img || THCX2Img,
      title: content.free_tv_channel_7_name || 'The Homestyle Channel',
    },
    {
      img: content.free_tv_channel_8_img || giggleMugImg,
      imgX2: content.free_tv_channel_8_img || giggleMugX2Img,
      title: content.free_tv_channel_8_name || 'Giggle Mug',
    },
  ];

  return (
    <div className="channels section section--grey">
      <div className="page-content">
        <Typography
          className="section__title channels__title"
          align="center"
          component="h2"
          variant="h3"
        >
          <Trans
            i18nKey="freeTv.channels.title"
            components={{
              span: <span className="text-color--purple" />,
            }}
          />
        </Typography>
        <Typography className="channels__subtitle body3 m-b-40" align="center">
          {t('freeTv.channels.subtitle')}
        </Typography>
        <Grid className="channels__list list" container spacing={4}>
          {channelsData.map((item, idx) => (
            <Grid item xs={6} sm={4} md={3} key={idx}>
              <Tooltip title={item.title}>
                <div className="list__item">
                  <img
                    className="list__img"
                    srcSet={`${item.imgX2} 2x`}
                    src={item.img}
                    alt={item.title}
                  />
                </div>
              </Tooltip>
            </Grid>
          ))}
        </Grid>
      </div>
    </div>
  );
};

export default React.memo(Channels);
